import React from "react";
import { useField, useFormikContext } from "formik";
import { ImagePreview } from "./ImagePreview";
import type { ImagePreviewBaseProps } from "./ImagePreview";

interface FormikImagePreviewProps
	extends Omit<
		ImagePreviewBaseProps,
		"image" | "onChange" | "hasError" | "errorText"
	> {
	name: string;
}

export const FormikImagePreview: React.FC<FormikImagePreviewProps> = ({
	name,
	...props
}) => {
	const [field, meta] = useField(name);
	const { setFieldValue, setFieldTouched } = useFormikContext();

	const hasError = !!(meta.error && meta.touched);

	const handleChange = (file: File | null) => {
		setFieldValue(name, file, true);
	};

	return (
		<ImagePreview
			{...props}
			image={field.value || null}
			onChange={handleChange}
			hasError={hasError}
			errorText={meta.touched ? meta.error : undefined}
		/>
	);
};
